import useAnalytics from '@globals/composables/analytics';
import { useAppStore } from '@globals/stores/app';
import { getDeviceType, getDeviceData, getUserAgent } from '@globals/utilities/GetDeviceType';
import { getAppType } from '@globals/utilities/isMobileApp';
import jsonFetch from './jsonFetch';
export default class PushNotifications {
	Messaging: any = null;
	UserId: number | null = null;
	Token: string | null = null;
	App: any = null;

	constructor(userId: number | null, frontEndDebug = false, appType: string) {
		this.UserId = userId;

		fetch(`/firebase/configuration/oferteopwa.do`)
			.then((resp) => resp.json())
			.then((config) => {
				window.setTimeout(() => {
					try {
						if (appType === 'default') {
							if (!firebase.apps.length) {
								firebase.initializeApp(config);
							}
							this.Messaging = firebase.messaging();
						}
						if (typeof this.UserId === 'number') {
							this.GetToken(this.UserId, frontEndDebug);
						}
					} catch (err) {
						console.warn(err);
					}
				}, 100);
			})
			.catch((err) => {
				console.error('Błąd pobierania konfiguracji Firebase:', err);
			});
	}

	TokenRefresh() {}

	async AskAndSubscribePush(userId, frontEndDebug = false) {
		const appType = await getAppType();
		if (appType === 'default') {
			if (!this.Messaging) {
				window.setTimeout(() => {
					this.AskAndSubscribePush(userId, frontEndDebug);
				}, 1500);
				return;
			}
			this.Dim('show');
			try {
				if (frontEndDebug) {
					alert(`AskAndSubscribePush userId:${userId}`);
				}
				if (this.Messaging && typeof this.Messaging.requestPermission !== 'undefined') {
					try {
						await this.Messaging.requestPermission();
						this.Dim('hide');
					} catch (err) {
						this.Dim('hide');
					}
				} else if (frontEndDebug) {
					alert('Request permission method is undefined');
				}
				this.Dim('hide');
			} catch (err) {
				this.Dim('hide');
				console.warn('Zgoda na powiadomienia nie została udzielona');
			}
		}
	}

	Dim(method = 'show') {
		const appStore = useAppStore();
		appStore.isScreenDimmed = method === 'show';
	}

	async SubscribeUserPushToken(userId: number | null, token: string | null) {
		const appType = await getAppType();
		const url = `/push/json/subscribe.ofer?userPushToken.idUser=${userId}&userPushToken.token=${token}&userPushToken.deviceData=${getDeviceData()}&userPushToken.agent=${getUserAgent()}&userPushToken.deviceType=${getDeviceType()}&userPushToken.appType=${appType}`;
		await fetch(url);
	}

	async EmptyToken(userId: number | null) {
		const appType = await getAppType();
		const url = `/push/json/emptyToken.ofer?userPushToken.idUser=${userId}&userPushToken.deviceData=${getDeviceData()}&userPushToken.agent=${getUserAgent()}&userPushToken.deviceType=${getDeviceType()}&userPushToken.appType=${appType}`;
		await fetch(url);
	}

	async GetToken(userId: number, frontEndDebug = false) {
		if (frontEndDebug) {
			alert(`GetToken userId:${userId}`);
		}

		// get Token from mobileApp
		if (typeof getFCMtoken !== 'undefined') {
			if (frontEndDebug) { alert('getFCMtoken != undefined'); }
			this.Token = await getFCMtoken();
			if (frontEndDebug) { alert(`this.Token:${this.Token}`); }
			if (this.Token) {
				if (frontEndDebug) { alert(`SubscribeUserPushToken userId:${userId}, this.Token:${this.Token}`); }
				await this.SubscribeUserPushToken(userId, this.Token);
				if (frontEndDebug) { alert('SubscribeUserPushToken ok'); }
				return this.Token;
			}
			await this.EmptyToken(userId);
		}

		if (frontEndDebug) {
			alert(`this.Token:${this.Token}`);
		}

		// get token from browser
		if (!this.Token) {
			if (typeof Notification !== 'function') {
				if (frontEndDebug) {
					alert('Notification is undefined, cannot get token');
				}
				console.warn('Notification is undefined, cannot get token');
				return;
			}

			if (frontEndDebug) {
				alert(`Notification.permission:${Notification.permission}`);
			}
			if (Notification.permission === 'granted') {
				if (frontEndDebug) {
					alert('this.Messaging.getToken() START');
				}
				await this.Messaging.getToken(this.Messaging).then(async (token: string) => {
					if (frontEndDebug) {
						alert(`this.Messaging.getToken() token:${token}`);
					}
					if (token) {
						this.Token = token;
						await this.SubscribeUserPushToken(userId, token);
					} else {
						console.warn('GetToken(), No token available from Messaging.getToken()');
					}
				}).catch((err) => {
					console.warn('GetToken(), Error retrieving token from Messaging.getToken()', err);
				});
				if (frontEndDebug) {
					alert('this.Messaging.getToken() END');
				}
			}
		}
	}

	async EnablePushNotifications(source = '') {
		await this.AskAndSubscribePush(this.UserId);

		if (source && typeof Notification === 'function' && Notification.permission === 'granted') {
			const analytics = useAnalytics();
			analytics.sendGAEvent(source);
			if (source === 'PushActv_PopUp') {
				await this.GetToken(this.UserId || 0);
				jsonFetch('/user/note-user-action-by-name.do', {
					method: 'POST',
					body: {
						actionType: 'BTN_CONFIRM_CLICK',
						actionGroup: 'PUSH_NOTIFICATION_MODAL',
						actionParameters: {},
					},
				});
			}
		}
	}
}
